import React from "react";
import ContactForm from "../../components/User/ContactForm";

const Contact = () => {
  return <ContactForm />;
};

export default Contact;
